import { combineReducers } from "redux";

import * as memberTierCustomer from "./getMemberTierCustomer";
import * as isLoading from "./isLoading";

export const reducer = combineReducers({
  memberTierCustomer: memberTierCustomer.reducer,
  memberTier: memberTierCustomer.reducer,
  isLoading: isLoading.reducer,
});

export interface StoreState {
  memberTierCustomer: memberTierCustomer.StoreState;
  memberTier: memberTierCustomer.StoreState;
  isLoading: isLoading.StoreState;
}
